import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Tabs = (props) => {
  const [activeTab, setTab] = useState(props.tabs[0].key);

  return (
    <div className="tabs">
      <div className="tabs-headings">
        {props.tabs.map((tab) => (
          <div
            className={`tab ${activeTab === tab.key ? 'tab--active' : ''}`}
            onClick={() => setTab(tab.key)}
            key={tab.key}
          >
            {tab.name}
          </div>
        ))}
      </div>

      <div className="tabs-content">
        {props.tabs.map(
          (tab) =>
            activeTab === tab.key && <div key={tab.key}>{tab.content}</div>
        )}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
      content: PropTypes.object,
    })
  ),
};

export default Tabs;
